var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"selector-wrapper"}},_vm._l((_vm.platforms),function(item,index){return _c('div',{key:index,staticClass:"item",style:({
      borderBottom:
        _vm.value == item.data ? '2px solid #6166EA' : 'solid 2px transparent',
    }),on:{"click":function($event){return _vm.updateValue(item.data)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }